/*****
 * Created by Allan on 2022/08/03.
 * Contact 84880528@qq.com.
 * 全局储存本地数据
 * *****/
import Vue from 'vue'
import Vuex from 'vuex'
import user from './module/user'
import global from './module/global'
Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production', //在非生产环境下，使用严格模式
    modules:{
        user,
        global,
    }
})



// WEBPACK FOOTER //
// ./src/repayment/store/index.js